var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toptext_wrap"},[_c('div',{staticClass:"container"},[_c('path',{attrs:{"d":"M20,230 Q40,205 50,230 T90,230","fill":"none","stroke":"blue","stroke-width":"5"}}),_vm._v(" "),_c('b-jumbotron',{staticStyle:{"color":"white","background-color":"rgba(0, 0, 0, 0)"},attrs:{"header":_vm.header,"lead":_vm.leader}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40a90979","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/components/Banner.vue
// module id = null
// module chunks = 